import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const dremio = defineConnector({
  identifier: "dremio",
  name: "Dremio",
  tagLine: "Data lakehouse platform",
  logo,
  protocol: "http",
  tags: ["data", "engineering"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create a personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Dremio, create a personal access token and send it as a bearer token for REST API calls.",
        },
      ],
    },
    {
      title: "Enter your Dremio details",
      items: [
        {
          kind: "url",
          label: "Dremio base URL",
          required: true,
          placeholder: "https://your-company.dremio.cloud",
          target: { kind: "configuration", field: "instanceUrl" },
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) =>
      `${instanceUrl || "https://your-company.dremio.cloud"}/api/v3/catalog`,
  },
  defaultUrlPattern: ({ instanceUrl }) =>
    urlToPattern(instanceUrl, "https://.*\\.dremio\\..*/.*"),
});
